<template>
  <div class="bb-file-table">
    <div
      v-if="typeIcon"
      class="bb-file-table__file"
      v-html="typeIcon"
      @click="onDownloadFile"
    />
  </div>
</template>

<script>
import {get} from 'lodash'
import {TemplateIcon, MultyTemplateIcon} from '@/constants/icon'
import UploadFileApi from '@/api/UploadFile/api'
import b64toBlob from 'b64-to-blob'
import { saveAs } from 'file-saver'

export default {
  name: 'FileTable',
  props: {
    row: {
      type: Object,
      default: () => ({})
    },
    column: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
  }),
  computed: {
    currentFiles () {
      const { prop } = this.column
      return get(this.row, prop, [])
    },
    typeIcon () {
      if (!this.currentFiles.length) return
      return this.currentFiles.length === 1 ? TemplateIcon() : MultyTemplateIcon()
    }
  },
  methods: {
    onDownloadFile () {
      this.currentFiles.forEach((el) => {
        this.getFileById(el)
      })
    },
    async getFileById (file) {
      try {
        const { data } = await UploadFileApi.getFile(file, true)
        const { base64, type, label } = data
        const blob = b64toBlob(base64, type)
        saveAs(blob, label)
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/variables";

  .bb-file-table {
    display: flex;
    align-items: center;

    &__file {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background: $color-wild-sand;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/FileTable/FileTable.vue